export const getCarNameLabel = (car: IProductModel | null) => {
	if (!car) return null
	return [car.brand, car.name].filter(Boolean).join(' ').trim() || null
}

export const getCarPricePerDay = (car: IProductModel | null) => {
	if (!car) return 0
	const price = car.segment.promotionalPrice?.amountGross ?? car.segment.regularPrice?.amountGross ?? car.segment.pricePerDay
	return Number(price).toFixed(2)
}

export const getCarPrice = (car: IProductModel | null, days: number | null = 1) => {
	if (!car) return 0
	const price = car.segment.promotionalPrice?.amountGross ?? car.segment.regularPrice?.amountGross ?? car.segment.pricePerDay
	return (Number(price) * (days ?? 1)).toFixed(2)
}

export const getCarSegmentLabel = (car: IProductModel | null) => {
	if (!car) return null
	return (car.segment?.nameEN || car.segment?.name)?.trim() || null
}

export const getCarGroups = (car: IProductModel | null) => {
	if (!car) return null
	return car.segment.groups?.map((g) => g?.name?.toLowerCase())
}
